import { StrutturaDTO } from "@app/shared/dto/strutturaDTO";
import { VoceCorrelataClassificaDTO } from "@app/shared/dto/voce-correlata-classificaDTO";
import { TipologiaFascicoloCorrelataDTO } from "./tipologia-fascicolo-correlataDTO";
import { VersioneFuturaDTO } from "./versione-futuraDTO";

export class VoceClassificaDTO {
  id: string;
  ente: string;
  codice: string;
  nome: string;
  descrizione: string;
  dataCreazione: string;
  dataModifica: string;
  dataInizioValidita: string;
  dataFineValidita: string;
  riferimentiNormativi: string;
  vociCorrelate: VoceCorrelataClassificaDTO[];
  struttureCollegate: StrutturaDTO[];
  struttureProprietarie: StrutturaDTO[];
  tipologieFascicolo: TipologiaFascicoloCorrelataDTO[];
  countChildren: number;
  versioneFutura: VersioneFuturaDTO;
  cancellata: boolean;
  abilitaInvioComunicazioniDipendenti: boolean;
}
